import React from 'react';
import { observer } from 'mobx-react-lite';
import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';

import { TournamentHasClaimModal } from './tournament-has-claim-modal';
import { TournamentFinishedModal } from './tournament-finished-modal';
import { TournamentInfoModal } from './tournament-info-modal';
import { AspectRatioImage } from '../cashback/ratio-image';
import { TournamentOpener } from './tournament-opener';
import { TournamentFrame } from './tournament-frame';
import { isDatePassed } from '../../../../helpers';
import { useStore } from '../../../../hooks';

import './style.scss';

interface TournamentProps {

}

export const Tournament: React.FC<TournamentProps> = observer(() => {

  const { tournamentStore, gameStore, userActivityStore } = useStore();
  const { launchData: { data: launchData }, gameReady, gameId } = gameStore;
  const { tournamentFrameOpen, tournamentFinishedModalOpen, tournamentHasClaimModalOpen, tournamentInfoModalOpen, showTournamentInfo, showTournamentOpener,  } = tournamentStore;

  const tournamentInfo = launchData?.tournamentInfo;
  /**
   * @description Evaluated on every render - `gameReady` flips after the launch data arrives, so the
   * end date is re-checked against the current time and an already finished tournament never opens.
   */
  const showTournamentInfoModal = gameReady && tournamentInfoModalOpen && showTournamentInfo
    && !!tournamentInfo && !isDatePassed(tournamentInfo.endDate);

  const handleOpenerClick = () => {
    userActivityStore.sendTrackUserActivity({
      category: UserActivityCategory.PromoTools,
      type: UserActivityTypes.TournamentWidget
    });
    tournamentStore.openTournamentFrame(null);
  };

  return (
    <>
      <div className="tournament-wr">
        <AspectRatioImage />
        {showTournamentOpener && <TournamentOpener gameId={gameId} onClick={handleOpenerClick} />}
      </div>
      {tournamentFinishedModalOpen && <TournamentFinishedModal />}
      {launchData?.hasTournament && <TournamentFrame isOpen={tournamentFrameOpen} />}
      {(showTournamentInfoModal && tournamentInfo) && <TournamentInfoModal data={tournamentInfo} />}
      {(gameReady && tournamentHasClaimModalOpen && !!launchData?.hasClaim) && <TournamentHasClaimModal />}
    </>
  );
});
